import { render } from "./LoaderMaskComponent.vue?vue&type=template&id=505207a1&scoped=true"
const script = {}

import "./LoaderMaskComponent.vue?vue&type=style&index=0&id=505207a1&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505207a1"]])

export default __exports__